<template>
  <div class="enterSecretQuestion-screen">
    <div class="leftContent">
      <custom-header :img-number="14"></custom-header>
    </div>
    <div class="rightContent">
      <div class="headBlock">
        <custom-header />
      </div>
      <div class="wrap enterSecretQuestion_content">
        <div class="grow"></div>
        <h2 v-text="$ml.get('setPromptSecretQuestionTitleReg')"></h2>
        <div class="textarea" :class="{notValid: isNotValid}">
          <textarea v-model="inputValue" @keydown.enter.exact.stop.prevent="nextScreen" maxlength="180" />
          <div v-if="isNotValid && isNotValidMessage" class="validText">{{ isNotValidMessage }}</div>
        </div>

        <div class="grow"></div>
        <div class="bottom">
          <div class="left">
            <custom-button :button-text="$ml.get('back')" back :action="back"></custom-button>
          </div>
          <div class="right">
            <custom-button :button-text="$ml.get('next')" success :disabled="disabledButton" :action="nextScreen"></custom-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomHeader from '../../components/ui/custom-header';
import CustomButton from '../../components/ui/custom-button';
import Profile from '../../helpers/profile';
import {registerProfile as apiRegisterProfile, setSecretData, verifySecretCode, recoverySetSecretAnswers, getApiErrorMessage} from '../../helpers/api';

export default {
  name: 'setPromptSecretQustionPage',
  components: {CustomButton, CustomHeader},
  data() {
    return {
      inputValue: Profile.registerTip,
      isNotValid: false,
      isNotValidMessage: this.$ml.get('secretQuestionErrorAnswer'),
      isErrorTimeout: null,
      isLoading: false,
    };
  },
  computed: {
    disabledButton: function() {
      return this.validHint.length === 0 || this.isLoading;
    },
    validHint: function() {
      return this.inputValue.replace(/\s+/g, ' ').trim();
    },
  },
  methods: {
    nextScreen: function() {
      if (this.inputValue.toLowerCase().trim() === Profile.registerAnswer.toLowerCase()) {
        this.showError(this.$ml.get('errorSameTip'));
        return;
      }
      Profile.setData({
        registerTip: this.validHint,
      });
      if (Profile.process === 'login') {
        this.nextLoginScreen();
      } else if (Profile.process === 'accessRecovery') {
        this.nextRecoveryScreen();
      } else {
        this.nextRegisteredScreen();
      }
    },

    back: function() {
      this.$router.back();
    },
    nextLoginScreen: function() {
      if (this.isLoading) return;
      //сохраняем пинкод и логинимся с ним
      this.isLoading = true;
      setSecretData()
        .then(
          () => {},
          err => {
            this.showError(getApiErrorMessage(err));
          }
        )
        .finally(() => {
          this.isLoading = false;
        });
    },

    nextRegisteredScreen: function() {
      if (this.isLoading) return;
      if (Profile.otptype !== 'email') {
        this.$router.push('/registration/enterEmailPage');
        return;
      }
      this.isLoading = true;
      apiRegisterProfile(true)
        .then(
          () => {
            this.$router.push({name: 'RegistrationFinish'});
          },
          err => {
            this.showError(
              getApiErrorMessage(err, {
                '406': this.$ml.get('errorUserAlreadyExist'),
              })
            );
          }
        )
        .finally(() => {
          this.isLoading = false;
        });
    },

    nextRecoveryScreen: function() {
      if (this.isLoading) return;
      this.isLoading = true;
      recoverySetSecretAnswers()
        .then(
          () => {
            this.$router.push({name: 'AccessRecoveryFinish'});
          },
          err => {
            this.showError(
              getApiErrorMessage(err, {
                '401': this.$ml.get('errorUserAlreadyExist'),
              })
            );
          }
        )
        .finally(() => {
          this.isLoading = false;
        });
    },

    showError: function(message = '') {
      this.isNotValidMessage = message;
      this.isNotValid = true;
      clearTimeout(this.isErrorTimeout);
      this.isErrorTimeout = setTimeout(() => {
        this.isNotValidMessage = '';
        this.isNotValid = false;
      }, 3000);
    },
  },
};
</script>

<style lang="scss" scoped>
.enterSecretQuestion_content {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 150px);
  justify-content: space-between;
  padding: 10% 6% 0;
}
.textarea {
  box-sizing: border-box;
  margin-top: 26px;
  margin-bottom: 26px;
  &:focus {
    outline: none;
  }
  textarea {
    resize: none;
    height: 100px;
    width: 100%;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    outline: none;
    color: rgba(0, 0, 0, 0.87);
    caret-color: #33332f;
    padding: 12px;
    border: 1px solid #bdd6e6;
    border-radius: 8px;
    box-sizing: border-box;
    background: transparent;
    box-shadow: none;
    font-family: NovaPoshta, Avenir, Helvetica, Arial, sans-serif;
  }
  textarea:focus {
    padding: 11px;
    border: 2px solid #5cd69b;
    box-sizing: border-box;
    border-radius: 8px;
  }
  &.notValid textarea {
    padding: 11px;
    border: 2px solid #ec3421;
    box-sizing: border-box;
    border-radius: 8px;
  }
  &::placeholder {
    color: #d9d9d9;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
  }
  .validText {
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    margin-top: 4px;
    margin-left: 12px;
    color: #e53935;
    text-align: left;
    padding-right: 5px;
  }
}
@media (min-width: 601px) and (max-width: 750px) {
  .enterSecretQuestion_content {
    height: calc(100vh - 220px);
    max-height: 700px;
  }
}
@media (min-width: 751px) {
  .enterSecretQuestion_content {
    height: calc(100vh - 220px);
    max-height: 700px;
  }
}
</style>
